import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { contactQueryKeys } from "../api/contact";

export const useCreateDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dealApi.createDeal,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.byContact(variables.contactUuid),
      });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.activities(variables.contactUuid),
      });
    },
  });
};
